// EVA-296: the floating Value Conclusion panel's pure logic — bps boundary
// rules and the per-valuation disclosure memory. Pure ESM so spec/javascript
// can probe it; the component owns markup and fetching only.

import { adjustByBasisPoints } from '../utils/decimalInput.js'

// A Discount Rate may reach zero; an Exit Cap Rate must stay above it — a
// zero cap rate divides the sale price away, and the engine answers with an
// unavailable bridge rather than infinity.
export function nextDiscountRate(current, basisPoints) {
  return adjustByBasisPoints(current, basisPoints)
}

export function nextExitCapRate(current, basisPoints) {
  const next = adjustByBasisPoints(current, basisPoints)
  if (next === null) return null
  return Number(next) > 0 ? next : null
}

export function canAdjustDiscountRate(current, basisPoints) {
  return nextDiscountRate(current, basisPoints) !== null
}

export function canAdjustExitCapRate(current, basisPoints) {
  return nextExitCapRate(current, basisPoints) !== null
}

// Valuation sub-tabs are separate Turbo visits, so the panel re-mounts on
// every navigation; the expansion state survives in sessionStorage instead.
// Keyed per valuation — carrying one valuation's open panel onto another
// would present the wrong conclusion as already inspected. Storage can be
// unavailable (private mode); the panel then simply starts collapsed.
export function expansionKey(valuationId) {
  return `eva-value-conclusion-expanded-${valuationId}`
}

export function readExpansion(storage, valuationId) {
  try {
    return storage.getItem(expansionKey(valuationId)) === 'true'
  } catch {
    return false
  }
}

export function writeExpansion(storage, valuationId, expanded) {
  try {
    if (expanded) storage.setItem(expansionKey(valuationId), 'true')
    else storage.removeItem(expansionKey(valuationId))
  } catch {
    // Storage refused (private mode, quota): the preference is a convenience,
    // losing it must not break the toggle itself.
  }
}
